export const WaitingView = () => {
  return (
    <div>
      <h2>Waiting for Pokemon selection</h2>
    </div>
  );
};

export default WaitingView;
